import { DialogActions } from '@mui/material';
import { APPROVAL_TYPES, COMITEE_TYPES } from 'lib/api/approvals/types';
import CustomButton from 'lib/designSystem/Button';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import Committee from 'pages/Finance/Components/Financing/common/Comittee';
import { ComiteeTabProvider } from 'pages/Finance/Components/Financing/common/Comittee/ComiteeTabProvider';
import React from 'react';

import VerificationModule from '../../../../../../../../Collection/components/Verification';

const FactoringOperationsTab = (props: any) => {
  const { setOpenShoppingCart, selectedRequest, setUp } = props;
  const startValue = 0;

  const ImportedModuleLayout = (props: any) => {
    return (
      <div>
        {props.children}
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingCart(false)}
            color="secondary"
            style={{ marginTop: '10px' }}
          >
            {' '}
            Salir{' '}
          </CustomButton>
        </DialogActions>
      </div>
    );
  };

  const comiteeTabInfo = {
    requestType: APPROVAL_TYPES.FACTORING_QUOTE,
    comiteeType: COMITEE_TYPES.OPERATIONS,
    requestId: selectedRequest.quoteActive.id,
    comiteeId: selectedRequest.quoteActive.comiteeOperations?.id ?? undefined,
    canEdit: selectedRequest.status === 'Aceptada',
    isRejected: selectedRequest.status === 'Rechazada',
    isActive: ['Completada', 'Activa', 'En giro'].includes(
      selectedRequest.status,
    ),
    refreshRequest: () => setUp(selectedRequest.id),
  };

  const tabs = [
    {
      index: 1,
      label: 'Comité',
      component: (
        <ImportedModuleLayout>
          <ComiteeTabProvider info={comiteeTabInfo}>
            <Committee />
          </ComiteeTabProvider>
        </ImportedModuleLayout>
      ),
    },
    {
      index: 2,
      label: 'Verificación',
      component: (
        <VerificationModule
          preSettedFactoringRequestId={selectedRequest?.id}
          preSettedConfirmationType="all"
          setOpenShoppingCart={setOpenShoppingCart}
          showCreditLine
        />
      ),
      path: 'recieved',
    },
  ];

  return <EnhancedTab startValue={startValue} tabs={tabs} />;
};

export default FactoringOperationsTab;
